import http from 'services/http';
import URIS from 'constants/uris';

export function getPaymentMethods(country) {
  return http
    .get(`${URIS.SHOP_PAYMENT_TYPES}?country=${country}`)
    .then(({ data }) => data);
}
